export * from './fuse.provider';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';

export const mockApiServices = [
    // AcademyMockApi,
    // ActivitiesMockApi,
    // AnalyticsMockApi,
    // AuthMockApi,
    // ChatMockApi,
    // ContactsMockApi,
    // CryptoMockApi,
    // ECommerceInventoryMockApi,
    // FileManagerMockApi,
    // FinanceMockApi,
    // HelpCenterMockApi,
    // IconsMockApi,
    // MailboxMockApi,
    // MessagesMockApi,
    NavigationMockApi,
    // NotesMockApi,
    // NotificationsMockApi,
    // ProjectMockApi,
    // SearchMockApi,
    // ScrumboardMockApi,
    // ShortcutsMockApi,
    // TasksMockApi,
    // UserMockApi
];

